/* eslint-disable no-useless-computed-key */
/* eslint-disable import/no-cycle */
import { FC, useContext, useEffect, useState } from 'react';
import clsx from 'clsx';
import { useRollbar } from '@rollbar/react';
import { ChallengeTabs, getChallengeBaseUrl } from '../../models/Challenge';

import Button from '../Button';
import ChallengeHero from '../ChallengeHero';
import ContentModalContext from '../../AppContext/ContentModalProvider';
import { IChallengeProps, IChallengeTab } from '../../models/Challenge/@types';
import MediaCardForVideo from '../MediaCards/MediaCardForVideo';
import { OVERVIEW_TAB } from '../../Constants/variables';
import ScrollButton from '../ScrollButton';
import SectionWrapper from '../SectionWrapper';
import { TMessagingBlade } from '../../models/Message/@types';
import Widgets from '../../blades/Widgets';
import { getMessageData } from '../../models/Message/api';
import { getTabLink } from '../../utils/helpers';
import { useIsMobileViewport } from '../../hooks/useIsMobileViewport';
import styles from './challengeDetail.module.sass';
import useErrorHandlers from '../../hooks/useErrorHandlers';

const ChallengeDetail: FC<IChallengeProps> = props => {
  const { currentTab, isPreview } = props;
  const rollbarCall = useRollbar();
  const { handleError } = useErrorHandlers();
  useEffect(() => {
    const networkError = localStorage.getItem('networkError');
    if (networkError) {
      rollbarCall.info(`Something Went Wrong: ${networkError}`);
      localStorage.removeItem('networkError');
      handleError({
        code: 'ERR_NETWORK',
      });
    }
  }, [handleError, rollbarCall]);
  useEffect(() => {
    const fetchData = async () => {
      const challengeTutorial = await getMessageData(['Tutorial - Challenge']);
      setModalData(challengeTutorial['Tutorial - Challenge']);
    };
    fetchData();
  }, []);
  const [modalData, setModalData] = useState<TMessagingBlade>();
  const [widgetArray, setWidgetArray] = useState(
    // eslint-disable-next-line react/destructuring-assignment
    props[currentTab?.widgetKey ?? OVERVIEW_TAB],
  );
  const [previewCurrentTab, setPreviewCurrentTab] = useState<IChallengeTab>(ChallengeTabs[0]);

  const { showModal, hideModal } = useContext(ContentModalContext);

  const { isMobile } = useIsMobileViewport();
  const baseUrl = getChallengeBaseUrl(props);
  // eslint-disable-next-line react/destructuring-assignment
  // const widgetArray = props[currentTab?.widgetKey ?? OVERVIEW_TAB];
  // if (typeof query.slug !== "undefined" && query.slug.length > 0) {
  //   requiredContentIndex = firstLevelTabSlugs.indexOf(query.slug[1]);
  // }

  const { launchDate } = props;

  return (
    <div className={styles.rootMain}>
      <ChallengeHero {...props} />
      {launchDate && new Date(launchDate) <= new Date() && (
        <>
          <SectionWrapper classes={`${styles.tabsContainer}`}>
            {/* <div> */}
            <div className={`${styles.tabs}`}>
              {ChallengeTabs.map(tab => (
                <Button
                  ariaLabel={tab.slug}
                  key={tab.slug}
                  onlyText
                  eventLink={!isMobile}
                  underline
                  // classes={`${tab.slug === currentTab?.slug ? "selected" : ""}`}
                  classes={clsx(styles.tabItem, {
                    ['selected']:
                      tab.slug === currentTab?.slug ||
                      (isPreview && tab.slug === previewCurrentTab.slug),
                  })}
                  {...{
                    ...(isPreview
                      ? {
                          onClick: () => {
                            // eslint-disable-next-line react/destructuring-assignment
                            setWidgetArray(props[tab.widgetKey]);
                            setPreviewCurrentTab(tab);
                          },
                        }
                      : {
                          link: getTabLink(tab, baseUrl, tab.widgetKey),
                        }),
                  }}
                >
                  {isPreview ? tab.name : null}
                </Button>
              ))}
            </div>
            <Button
              theme="Transparent - Blue Border"
              onClick={() =>
                showModal(<MediaCardForVideo open onClose={hideModal} {...modalData} isTutorial />)
              }
            >
              Challenge Tutorial
            </Button>
          </SectionWrapper>
          <Widgets widget={widgetArray} customCss />
          <ScrollButton />
        </>
      )}
    </div>
  );
};

export default ChallengeDetail;
